import React, { useEffect } from "react";
import {
  Typography,
  Box,
} from "@mui/material";

const CustomerPage: React.FC = () => {

  useEffect(() => {
  }, []);


  return (

    <Box sx={{ padding: 2 }}>
      <Typography variant="h4" gutterBottom>
        Customer Map
      </Typography>

      <iframe width="1000" height="750"
        src="https://lookerstudio.google.com/embed/reporting/7e39ca39-740b-49c8-a2df-df192f88afdc/page/k7WyE"
        frameBorder={0}
        style={{ border: 0 }}
        allowFullScreen
        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox">
      </iframe>
    </Box>
  );
};


export default CustomerPage;
